import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "counter-modal-component" }
const _hoisted_2 = { class: "counterTitle" }
const _hoisted_3 = { class: "timer upperSpace" }
const _hoisted_4 = {
  width: "174",
  height: "174",
  viewBox: "0 0 174 174",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("filter", { id: "innerShadow" }, [
    /*#__PURE__*/_createElementVNode("feOffset", {
      dx: "0",
      dy: "-14"
    }),
    /*#__PURE__*/_createElementVNode("feGaussianBlur", {
      stdDeviation: "6",
      result: "offset-blur"
    }),
    /*#__PURE__*/_createElementVNode("feComposite", {
      operator: "out",
      in: "SourceGraphic",
      in2: "offset-blur",
      result: "inverse"
    }),
    /*#__PURE__*/_createElementVNode("feFlood", {
      "flood-color": "black",
      "flood-opacity": "1",
      result: "color"
    }),
    /*#__PURE__*/_createElementVNode("feBlend", {
      in: "SourceGraphic",
      in2: "floodFill",
      mode: "multiply"
    }),
    /*#__PURE__*/_createElementVNode("feComposite", {
      operator: "in",
      in: "color",
      in2: "inverse",
      result: "shadow"
    }),
    /*#__PURE__*/_createElementVNode("feComponentTransfer", {
      in: "shadow",
      result: "shadow"
    }, [
      /*#__PURE__*/_createElementVNode("feFuncA", {
        type: "linear",
        slope: ".25"
      })
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M174 87C174 135.049 135.049 174 87 174C38.9512 174 0 135.049 0 87C0 38.9512 38.9512 \n                      0 87 0C135.049 0 174 38.9512 174 87ZM22.2111 87C22.2111 122.782 51.2181 151.789 \n                      87 151.789C122.782 151.789 151.789 122.782 151.789 87C151.789 51.2181 122.782 22.2111\n                      87 22.2111C51.2181 22.2111 22.2111 51.2181 22.2111 87Z",
  fill: "#D9E9E2"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  d: "M174 87C174 135.049 135.049 174 87 174C38.9512 174 0 135.049 0 87C0 38.9512 38.9512 \n                    0 87 0C135.049 0 174 38.9512 174 87ZM22.2111 87C22.2111 122.782 51.2181 151.789 \n                    87 151.789C122.782 151.789 151.789 122.782 151.789 87C151.789 51.2181 122.782 22.2111\n                    87 22.2111C51.2181 22.2111 22.2111 51.2181 22.2111 87Z",
  fill: "#D9E9E2",
  filter: "url(#innerShadow)"
}, null, -1)
const _hoisted_8 = {
  ref: "circleCounter",
  id: "circleCounter",
  cx: "87",
  cy: "87",
  r: "76",
  stroke: "#4B665C",
  "stroke-width": "20",
  "stroke-dasharray": "477.52",
  "stroke-dashoffset": "0",
  "stroke-linecap": "round"
}
const _hoisted_9 = {
  id: "textCounter",
  x: "50%",
  y: "50%",
  ref: "textCounter",
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  style: {"font-family":"Montserrat, Open Sans","fill":"#151515","font-weight":"600","font-size":"25px","line-height":"24px"}
}
const _hoisted_10 = { class: "video-container" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "action-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_modal, {
      class: "custom-modal",
      ref: "base-modal"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, " Aguarde " + _toDisplayString(_ctx.StepContent.timerInMinutes) + " minutos ", 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock("svg", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("circle", _hoisted_8, null, 512),
            _createElementVNode("text", _hoisted_9, null, 512)
          ])),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("video", {
              src: _ctx.blankVideoPath,
              width: "1px",
              title: "keep awake",
              frameborder: "0",
              controls: "",
              loop: "",
              autoplay: ""
            }, [
              _createElementVNode("source", {
                src: _ctx.blankVideoPath,
                type: "video/webm"
              }, null, 8, _hoisted_12)
            ], 8, _hoisted_11)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "btn btn-default btn-primary upperSpace",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goAhead()))
          }, " Pular "),
          _createElementVNode("button", {
            class: "btn btn-default btn-secondary upperSpace",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goBack()))
          }, " Voltar ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}